import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { CheckOutService } from "../../../../services/checkout.service";
import { GetEndUserAddressBookOutput, GetEndUserSalesTypeOut } from "../../../../models/check-out.model";

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-select-end-user',
  templateUrl: './select-end-user.component.html',
  styleUrls: ['./select-end-user.component.css']
})
export class SelectEndUserComponent implements OnInit {

  title = 'Select End User';
  filterInput: string
  loadContent:boolean = false;
  salesTypes: GetEndUserSalesTypeOut[];
  // selectedSalesType: string;
  endUserAddressBooks: GetEndUserAddressBookOutput[];
  endUserAddressBooksFilter: GetEndUserAddressBookOutput[];

  constructor(
    private router: Router,
    private checkOutService: CheckOutService,
    private activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.loadContent = false;
    this.checkOutService.EndUserAddressBook("").subscribe((result: GetEndUserAddressBookOutput[]) => {
      this.endUserAddressBooks = result;
      this.endUserAddressBooksFilter = this.endUserAddressBooks;
      this.loadContent = true;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });

    // this.checkOutService.GetEndUserAddressSelectionView("").subscribe((res: GetEndUserSalesTypeOut[]) => {
    //   this.salesTypes = res;
    //   if (this.salesTypes && this.salesTypes.length) {
    //     // this.selectedSalesType = this.salesTypes[0].out_sales_type.split(' ')[0];
    //     this.checkOutService.EndUserAddressBook("").subscribe((result: GetEndUserAddressBookOutput[]) => {
    //       this.endUserAddressBooks = result;
    //       this.endUserAddressBooksFilter = this.endUserAddressBooks;
    //     },
    //       (error: any) => {
    //         console.error(error);
    //         this.loadContent = true;
    //       });
    //   }

    // },
    //   (error: any) => {
    //     console.error(error);
    //     this.loadContent = true;
    //   });
  }

  selectSalesType(salesType: string): void {
    this.endUserAddressBooks = [];
    this.endUserAddressBooksFilter = [];
    this.loadContent = false;
    this.checkOutService.EndUserAddressBook(salesType).subscribe((result: GetEndUserAddressBookOutput[]) => {
      this.endUserAddressBooks = result;
      this.endUserAddressBooksFilter = this.endUserAddressBooks;
      this.loadContent = true;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  searchEndUserAddressBook(): void {
    // this.endUserAddressBooksFilter = this.endUserAddressBooks.filter(addressBook =>
    //   addressBook.out_first_name.includes(this.filterInput) ||
    //   addressBook.out_last_name.includes(this.filterInput) ||
    //   addressBook.out_company_name.includes(this.filterInput) ||
    //   addressBook.out_email.includes(this.filterInput) ||
    //   addressBook.out_mobile.includes(this.filterInput) ||
    //   addressBook.out_phone.includes(this.filterInput)
    // );
    this.endUserAddressBooksFilter = this.endUserAddressBooks.filter((addressBook)=>{
      const array: string[] = [];
      array.push(addressBook.out_first_name+' '+addressBook.out_last_name,addressBook.out_company_name, addressBook.out_email,addressBook.out_mobile,
        addressBook.out_phone,addressBook.out_fax,addressBook.out_address_1,addressBook.out_address_2,addressBook.out_address_3,addressBook.out_address_4,
        addressBook.out_address_5,addressBook.out_suburb,addressBook.out_state,addressBook.out_country,addressBook.out_postcode);
       return array.some(line => line.toLocaleLowerCase().includes(this.filterInput.toLowerCase()));
      }
    );
  }

  selectEndUser(endUserAddressBook: GetEndUserAddressBookOutput): void {
    this.checkOutService.monitorSelectEndUser(endUserAddressBook);
    this.router.navigate(["./"], { relativeTo: this.activatedRoute.parent });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    this.router.navigate(['./'], {relativeTo: this.activatedRoute.parent});
  }
}
